export default "__VITE_ASSET__1c1fd4ba__"